import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/carriers/$annuityIntegrationId/')({
  beforeLoad: ctx => {
    throw redirect({
      params: ctx.params,
      replace: true,
      to:
        localStorage.getItem('isAdmin') === '1'
          ? '/carriers/$annuityIntegrationId/api-keys'
          : '/carriers/$annuityIntegrationId/transactions'
    });
  }
});
